module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n4n6n9n-77ac4d1b87a09a198cac3a4aa90374f7.svg";